import React from "react";
import ReactECharts from "echarts-for-react";


const StackedBarChart = ({ data }) => {
  const shortenLegendName = (value) => {
    const labelMap = {
      "ServiceOps Narrative": "SvcOps",
      "AIOps & Observability Narrative": "AIOps & Obs.",
      "One BMC Narrative - Mainframe & Distributed": "One BMC - Mainf. & Distr.",
      "End-to-End Observability Narrative with Live App": "E2E Obs.",
      "BMC Helix Platform Demo for Executives (CXO Dashboard Narrative)": "CXO Dash.",
      "Customer Service Management - CSM": "CSM",
      "Change Management DevOps meets ITIL": "Chg Mgmt",
      "Service Predictions": "Svc Pred.",
      "Security Incident Handling": "SIH",
      "Policy Based Clustering (Network Alerts)": "Policy Clustering",
      "The Complete Banking Story": "Complete Banking",
      "Agentic AI Driven HRSM": "HRSM",
      "HelixGPT - Vulnerability Resolver": "Vuln Ops"
    };
    return labelMap[value] || value || "Unknown"; 
  };

  const colors = [
    "#C3F2FA",
    "#C3CFFA",
    "#C3E0FA",
    "#89FAE6",
    "#708BA2",
    "#FEF2E8",
    "#CAF5C6",
  ];

  const categories = data?.map((item) => item.name || "Unknown");

  const series = Object.keys(data[0] || {})
    .filter((key) => key !== "name")
    .map((key, index) => ({
      name: shortenLegendName(key),
      type: "bar",
      stack: "total",
      data: data.map((item) => item[key] || 0),
      itemStyle: {
        color: colors[index % colors.length],
      },
    }));

  const options = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderColor: "#ccc",
      borderWidth: 1,
      borderRadius: 8,
      padding: [10, 15],
      textStyle: { color: "#333", fontSize: 14, fontFamily: "Arial, sans-serif" },
      formatter: (params) => {
        let total = params.reduce((sum, item) => sum + item.value, 0);
        let tooltip = `<div style="font-weight: bold; margin-bottom: 8px; color: #222;">Total Run - ${total}</div>`;
        tooltip += params
          .map(
            (item) =>
              `<div style="display: flex; justify-content: space-between;">
                  <span style="color:${item.color}; margin-right: 10px;">●</span> 
                  <span>${item.seriesName}: ${item.value}</span>
                </div>`
          )
          .join("");
        return tooltip;
      },
    },
    legend: {
      data: series.map((s) => s.name),
      bottom: 10,
      right: "2%",
      left: "2%",
      itemGap: 20,
      textStyle: {
        fontSize: 12,
        color: "#333",
        fontFamily: "Arial, sans-serif",
        fontWeight: "bold",
      },
      icon: "circle",
      backgroundColor: "#fff",
      borderColor: "#ddd",
      borderWidth: 1,
      borderRadius: 8,
      padding: [10, 15, 10, 15],
    },
    grid: {
      left: "40px",
      right: "40px",
      bottom: "30%",
      top: "10px",
    },
    xAxis: {
      type: "category",
      data: categories,
      axisLabel: { rotate: 0, fontSize: 10, color: "#666" },
      splitLine: { show: false },
    },
    yAxis: {
      type: "value",
      axisLabel: { fontSize: 12, color: "#666" },
      splitLine: { show: false },
    },
    dataZoom: [
      {
        type: "slider",
        xAxisIndex: 0,
        zoomLock: true,
        moveOnMouseMove: false,
        showDetail: false,
        showDataShadow: true,
        realtime: true,
        brushSelect: false,
        start: 0,
        end: 50,
        bottom: "100px",
        handleSize: "100%",
        handleStyle: { color: "#85D7FF", borderWidth: 1, borderColor: "#5AB1F6" },
        fillerColor: "rgba(133, 215, 255, 0.2)",
        borderColor: "transparent",
        textStyle: { color: "transparent" },
      },
    ],
    series: series,
  };

  return (
    <div className="stacked-bar-container">
      <ReactECharts option={options} style={{ height: "500px", width: "100%" }} />
    </div>
  );
};

export default StackedBarChart;
